"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagesFolderListActions = exports.EntryFolderListActions = void 0;
const _FolderListActions = require("../../modules/files/list/actions");
require("./list");
require("./current");
require("./comment");
require("./print");
require("./jobs");
require("./stats");
exports.EntryFolderListActions = _FolderListActions.default('entry-files');
exports.ImagesFolderListActions = _FolderListActions.default('entry-images');
//# sourceMappingURL=index.js.map